import { render, staticRenderFns } from "./Step01Partes.vue?vue&type=template&id=15f51c1d&scoped=true"
import script from "./Step01Partes.vue?vue&type=script&lang=js"
export * from "./Step01Partes.vue?vue&type=script&lang=js"
import style0 from "./Step01Partes.vue?vue&type=style&index=0&id=15f51c1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f51c1d",
  null
  
)

export default component.exports